import {isNullOrUndefined} from "../../../services/Validator";

export default function LevelATaskText({task}) {
    // Used in LevelAMetaData to display LevelA task

    // BUILD
    if (isNullOrUndefined(task))
        return null
    return (
        <span className={"font-semibold text-[22px] leading-tight"}>
            {task}
        </span>
    );
}